export type ChatConnectionStatus = 'connecting' | 'connected' | 'disconnected' | 'reconnecting';

interface ChatStatusProps {
  status: ChatConnectionStatus;
}

const statusConfig: Record<ChatConnectionStatus, { icon: string; label: string; color: string; bg: string; border: string }> = {
  connecting: {
    icon: 'ri-loader-4-line',
    label: 'Bağlanıyor...',
    color: 'text-cyan-400',
    bg: 'bg-cyan-500/10',
    border: 'border-cyan-500/25',
  },
  connected: {
    icon: 'ri-wifi-line',
    label: 'Bağlı',
    color: 'text-emerald-400',
    bg: 'bg-emerald-500/10',
    border: 'border-emerald-500/25',
  },
  disconnected: {
    icon: 'ri-wifi-off-line',
    label: 'Bağlantı Kesildi',
    color: 'text-red-400',
    bg: 'bg-red-500/10',
    border: 'border-red-500/25',
  },
  reconnecting: {
    icon: 'ri-refresh-line',
    label: 'Yeniden Bağlanıyor...',
    color: 'text-yellow-400',
    bg: 'bg-yellow-500/10',
    border: 'border-yellow-500/25',
  },
};

const ChatStatus = ({ status }: ChatStatusProps) => {
  const cfg = statusConfig[status];
  const isAnimated = status === 'connecting' || status === 'reconnecting';

  return (
    <div
      className={`flex items-center gap-2 px-3 py-1.5 rounded-full ${cfg.bg} border ${cfg.border} ${cfg.color} text-xs font-medium backdrop-blur-md`}
    >
      <i className={`${cfg.icon} text-sm ${isAnimated ? 'animate-spin' : ''}`} />
      {cfg.label}
    </div>
  );
};

export default ChatStatus;
